<template>
  <div class="liveListBox">
    <pageTitle :pageTitle="$t('lang.k_276001')">
      <div slot="content">
        {{ $t('lang.k_276002') }}
        <br />
        {{ $t('lang.k_276003') }}
        <br />
        {{ $t('lang.k_276004') }}
        <br />
        {{ $t('lang.k_276005') }}
      </div>
    </pageTitle>
    <!-- 操作栏  -->
    <div class="operaBox" v-if="totalElement || isSearch">
      <vh-dropdown
        v-if="vodPerssion == 1 || isTiming == 1"
        @command="createLiveAction"
        trigger="click"
      >
        <vh-button type="primary" round class="create_but_padding">
          <i class="vh-icon-plus"></i>
          {{ $t('lang.k_276006') }}
        </vh-button>
        <vh-dropdown-menu slot="dropdown" class="dropdown_width">
          <vh-dropdown-item
            type="primary"
            round
            command="1"
            v-preventReClick
            size="medium"
            class="length104"
          >
            {{ $t('lang.k_276007') }}
          </vh-dropdown-item>
          <vh-dropdown-item
            size="medium"
            round
            command="2"
            v-if="vodPerssion == 1"
            class="transparent-btn"
            v-preventReClick
          >
            {{ $t('lang.k_276008') }}
          </vh-dropdown-item>
          <vh-dropdown-item
            v-if="isTiming == 1"
            size="medium"
            round
            command="3"
            class="transparent-btn"
            v-preventReClick
          >
            {{ $t('lang.k_276009') }}
          </vh-dropdown-item>
        </vh-dropdown-menu>
      </vh-dropdown>
      <span v-else>
        <vh-button
          type="primary"
          round
          @click="createLiveAction('1')"
          v-preventReClick
          size="medium"
          class="length104"
        >
          {{ $t('lang.k_276007') }}
        </vh-button>
        <vh-button
          size="medium"
          round
          @click="createLiveAction('2')"
          v-if="vodPerssion == 1"
          class="transparent-btn"
          v-preventReClick
        >
          {{ $t('lang.k_276008') }}
        </vh-button>
        <vh-button
          v-if="isTiming == 1"
          size="medium"
          round
          @click="createLiveAction('3')"
          class="transparent-btn"
          v-preventReClick
        >
          {{ $t('lang.k_276009') }}
        </vh-button>
      </span>
      <div class="searchBox search-tag-box">
        <div class="changeOption">
          <span :class="{ 'span-active': activeStyle == 0 }" @click="changeStyle(0)">
            {{ $t('lang.k_276010') }}
          </span>
          <span :class="{ 'span-active': activeStyle == 1 }" @click="changeStyle(1)">
            {{ $t('lang.k_276011') }}
          </span>
        </div>
        <vh-select
          class="small"
          round
          v-model="modeType"
          :placeholder="$t('lang.k_276012')"
          @change="modeHandler"
        >
          <vh-option
            v-for="item in modeOptions"
            :key="item.value + item.label"
            :label="item.label"
            :value="item.value"
          ></vh-option>
        </vh-select>
        <vh-select
          round
          v-model="labelId"
          :placeholder="$t('lang.k_276013')"
          @change="labelHandler"
          class="small"
        >
          <vh-option
            v-for="item in labelList"
            :key="item.label_id"
            :label="item.name"
            :value="item.label_id"
          ></vh-option>
        </vh-select>
        <vh-select
          class="small"
          round
          v-model="liveStatus"
          :placeholder="$t('lang.k_276014')"
          @change="liveHandler"
        >
          <vh-option
            v-for="item in statusOptions"
            :key="item.value + item.label"
            :label="item.label"
            :value="item.value"
          ></vh-option>
        </vh-select>
        <vh-select
          round
          v-model="orderBy"
          :placeholder="$t('lang.k_276015')"
          @change="orderHandler"
        >
          <vh-option
            v-for="item in orderOptions"
            :key="item.value + item.label"
            :label="item.label"
            :value="item.value"
          ></vh-option>
        </vh-select>
        <vh-input
          round
          style="width: 230px"
          class="search-tag"
          :placeholder="$t('lang.k_276016')"
          v-model="keyWords"
          clearable
          v-clearEmoij
          @change="searchHandler"
          @keyup.enter.native="searchHandler"
        >
          <i class="vh-icon-search vh-input__icon" slot="prefix" @click="searchHandler"></i>
        </vh-input>
      </div>
    </div>
    <!-- 操作栏 -->
    <div v-if="totalElement">
      <!-- 卡片模式 -->
      <vh-row :gutter="24" class="lives" v-if="activeStyle == 0">
        <vh-col
          class="liveItem"
          :xs="8"
          :sm="8"
          :md="8"
          :lg="8"
          :xl="6"
          v-for="(item, index) in liveList"
          :key="index"
        >
          <!-- :xs="24" :sm="12" :md="12" :lg="8" :xl="6" -->
          <div @click="toLiveDetail(item.webinar_id)" class="inner">
            <!--  @click.prevent.stop="toDetail(item.webinar_id)" -->
            <div class="top">
              <span class="liveTag">
                <label class="live-status" v-if="item.webinar_state == 1">
                  <img src="../../common/images/live.gif" alt="" />
                </label>
                {{ item | liveTag }}
                <span
                  v-if="
                    item.is_new_version == 3 &&
                    (item.webinar_type == 3 || item.webinar_type == 6) &&
                    item.zdy_inav_num > 1
                  "
                >
                  | 1v{{ Number(item.inav_num) - 1 }}
                </span>
                <span v-if="item.webinar_type != 6 && isDelay && item.no_delay_webinar == 1">
                  {{ $t('lang.k_276017') }}
                </span>
                <span v-if="webinarDirector && item.is_director === 1">
                  {{ $t('lang.k_276018') }}
                </span>
                <span v-if="item.webinar_show_type == 0">{{ $t('lang.k_276019') }}</span>
              </span>
              <span class="hot">
                <i class="iconfont-v3 saasicon_redu">{{ item.pv | formatNum }}</i>

                <vh-tooltip placement="right" v-tooltipMove>
                  <div class="label-tip-content" slot="content">
                    {{ item.labelTips }}
                  </div>
                  <div class="card-display-label single-ellips">{{ item.displayLabel }}</div>
                </vh-tooltip>
              </span>
              <div class="img-box">
                <img
                  :class="`img_box_bg webinar_bg_${item.itemMode}`"
                  :src="`${item.img_url}`"
                  alt=""
                />
              </div>
              <!-- <div class=""></div> -->
            </div>
            <div class="bottom">
              <div class="live-title">
                <p class="liveTitle">{{ item.subject }}</p>
                <p class="liveTime">{{ item.start_time }}</p>
              </div>
              <p class="liveOpera" @click.stop="nullFunc">
                <vh-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('lang.k_276020')"
                  placement="top"
                  v-if="item.webinar_state != 4 && item.webinar_type != 5 && !isEmbed"
                  v-tooltipMove
                >
                  <i class="iconfont-v3 saasicon_kaibo" @click.prevent.stop="goLivePlay(item)"></i>
                  <!-- <router-link :to="`chooseWay/${item.webinar_id}/1`" target="_blank"><i class="vh-icon-video-camera"></i></router-link> -->
                </vh-tooltip>
                <vh-tooltip
                  v-tooltipMove
                  class="item"
                  effect="dark"
                  :content="$t('lang.k_276021')"
                  placement="top"
                  v-if="!(childPremission && Number(childPremission.permission_content) === 0)"
                >
                  <i
                    class="iconfont-v3 saasicon_huifang"
                    @click.prevent.stop="goPlayback(item)"
                  ></i>
                </vh-tooltip>
                <vh-tooltip
                  v-tooltipMove
                  class="item"
                  effect="dark"
                  :content="$t('lang.k_276022')"
                  placement="top"
                >
                  <i
                    class="iconfont-v3 saasicon_xiangqing"
                    @click.prevent.stop="toDetail(item.webinar_id)"
                  ></i>
                </vh-tooltip>
                <!-- isTiming == 1 -->
                <vh-tooltip
                  v-tooltipMove
                  class="item"
                  effect="dark"
                  :content="$t('lang.k_276023')"
                  placement="top"
                  v-if="item.webinar_type == 5 ? isTiming == 1 : true"
                >
                  <i
                    class="iconfont-v3 saasicon_copy1"
                    @click.prevent.stop="toCopy(item.webinar_id, item.webinar_show_type, item)"
                  ></i>
                </vh-tooltip>
                <vh-tooltip
                  v-tooltipMove
                  class="item"
                  effect="dark"
                  v-if="!isEmbed && permission.hidden_watch_url != 1"
                  :content="$t('lang.k_276024')"
                  placement="top"
                >
                  <i class="iconfont-v3 saasfenxiang_icon" @click.prevent.stop="toShare(item)"></i>
                </vh-tooltip>
                <span @click.prevent.stop>
                  <vh-dropdown
                    :class="{ active: !!item.liveDropDownVisible }"
                    trigger="click"
                    placement="top-end"
                    @visible-change="dropDownVisibleChange(item)"
                    v-if="
                      (permission?.view_report == 1 &&
                        !(childPremission && Number(childPremission.permission_data) === 0)) ||
                      !(childPremission && Number(childPremission.permission_webinar_delete) === 0)
                    "
                    @command="commandMethod"
                  >
                    <i class="iconfont-v3 saasicon_more2"></i>
                    <vh-dropdown-menu style="width: 98px; padding: 4px 0" slot="dropdown">
                      <vh-dropdown-item
                        command="/live/reportsData"
                        v-if="
                          permission?.view_report == 1 &&
                          !(childPremission && Number(childPremission.permission_data) === 0)
                        "
                      >
                        {{ $t('lang.k_276025') }}
                      </vh-dropdown-item>
                      <vh-dropdown-item
                        command="/live/interactionData"
                        v-if="
                          permission?.view_report == 1 &&
                          !(childPremission && Number(childPremission.permission_data) === 0)
                        "
                      >
                        {{ $t('lang.k_276026') }}
                      </vh-dropdown-item>
                      <vh-dropdown-item
                        command="/live/userData"
                        v-if="
                          permission?.view_report == 1 &&
                          !(childPremission && Number(childPremission.permission_data) === 0)
                        "
                      >
                        {{ $t('lang.k_276027') }}
                      </vh-dropdown-item>
                      <!-- <vh-dropdown-item command='/live/edit' v-if="item.webinar_state!=4">{{ $t('lang.k_276023') }}</vh-dropdown-item> -->
                      <vh-dropdown-item
                        v-if="
                          !(
                            childPremission &&
                            Number(childPremission.permission_webinar_delete) === 0
                          )
                        "
                        :command="$t('lang.k_276028')"
                      >
                        {{ $t('lang.k_276028') }}
                      </vh-dropdown-item>
                    </vh-dropdown-menu>
                  </vh-dropdown>
                </span>
              </p>
            </div>
            <transition name="vh-zoom-in-bottom">
              <div class="mask" v-show="!!item.liveDropDownVisible"></div>
            </transition>
          </div>
        </vh-col>
      </vh-row>
      <!-- 列表模式 -->
      <vh-table class="lives lives-list" v-else :data="liveList" row-class-name="liveItem">
        <vh-table-column :label="$t('lang.k_276029')" width="188">
          <template slot-scope="{ row }">
            <div class="top" @click="toLiveDetail(row.webinar_id)">
              <span class="liveTag">
                <label class="live-status" v-if="row.webinar_state == 1">
                  <img src="../../common/images/live.gif" alt="" />
                </label>
                {{ row | liveTag }}
                <span
                  v-if="
                    row.is_new_version == 3 &&
                    (row.webinar_type == 3 || row.webinar_type == 6) &&
                    row.zdy_inav_num > 1
                  "
                >
                  | 1v{{ Number(row.inav_num) - 1 }}
                </span>
                <span v-if="row.webinar_type != 6 && isDelay && row.no_delay_webinar == 1">
                  {{ $t('lang.k_276017') }}
                </span>
                <span v-if="webinarDirector && row.is_director === 1">
                  {{ $t('lang.k_276018') }}
                </span>
                <span v-if="row.webinar_show_type == 0">{{ $t('lang.k_276019') }}</span>
              </span>
              <span class="hot">
                <i class="iconfont-v3 saasicon_redu">{{ row.pv | formatNum }}</i>
              </span>
              <div class="img-box">
                <img
                  :class="`img_box_bg webinar_bg_${row.itemMode}`"
                  :src="`${row.img_url}`"
                  alt=""
                />
              </div>
              <!-- <div class=""></div> -->
            </div>
          </template>
        </vh-table-column>
        <vh-table-column :label="$t('lang.k_276030')" min-width="200">
          <template slot-scope="{ row }">
            <vh-tooltip :content="row.subject" placement="top-start" v-tooltipMove>
              <p class="liveTitle">{{ row.subject }}</p>
            </vh-tooltip>
          </template>
        </vh-table-column>
        <vh-table-column :label="$t('lang.k_276031')" width="140">
          <template slot-scope="{ row }">
            {{ row.webinar_id }}
          </template>
        </vh-table-column>
        <vh-table-column :label="$t('lang.k_276032')" width="140">
          <template slot-scope="{ row }">
            {{ row.created_at.slice(0, -3) }}
          </template>
        </vh-table-column>
        <vh-table-column :label="$t('lang.k_276033')" width="140">
          <template slot-scope="{ row }">
            {{ row.webinar_state != 4 ? row.start_time : '-' }}
          </template>
        </vh-table-column>
        <vh-table-column :label="$t('lang.k_276034')">
          <template slot-scope="{ row }">
            <span v-if="row.webinar_state != 4">{{ row.webinar_type | webinarTypeText }}</span>
            <span v-else>-</span>
          </template>
        </vh-table-column>
        <vh-table-column :label="$t('lang.k_276035')" width="60">
          <template slot-scope="{ row }">
            {{ row.webinar_state | actionText }}
          </template>
        </vh-table-column>
        <vh-table-column :label="$t('lang.k_276036')" width="120">
          <template slot-scope="{ row }">
            <template v-if="row.displayLabel">
              <vh-tooltip placement="right" v-tooltipMove>
                <div class="label-tip-content" slot="content">
                  {{ row.labelTips }}
                </div>
                <div class="single-ellips">
                  {{ row.displayLabel }}
                </div>
              </vh-tooltip>
            </template>
            <template v-else>--</template>
          </template>
        </vh-table-column>
        <vh-table-column :label="$t('lang.k_276037')" fixed="right" align="left" width="260">
          <template slot-scope="{ row }">
            <vh-button
              class="ctr_btn"
              type="text"
              v-if="row.webinar_state != 4 && row.webinar_type != 5 && !isEmbed"
              @click.prevent.stop="goLivePlay(row)"
            >
              {{ $t('lang.k_276020') }}
            </vh-button>
            <vh-button
              class="ctr_btn"
              v-if="!(childPremission && Number(childPremission.permission_content) === 0)"
              type="text"
              @click.prevent.stop="goPlayback(row)"
            >
              {{ $t('lang.k_276021') }}
            </vh-button>
            <vh-button class="ctr_btn" type="text" @click.prevent.stop="toDetail(row.webinar_id)">
              {{ $t('lang.k_276022') }}
            </vh-button>
            <vh-button
              class="ctr_btn"
              v-if="row.webinar_type == 5 ? isTiming == 1 : true"
              type="text"
              @click.prevent.stop="toCopy(row.webinar_id, row.webinar_show_type, row)"
            >
              {{ $t('lang.k_276023') }}
            </vh-button>
            <vh-button
              class="ctr_btn"
              v-if="!isEmbed && permission.hidden_watch_url != 1"
              type="text"
              @click.prevent.stop="toShare(row)"
            >
              {{ $t('lang.k_276024') }}
            </vh-button>

            <vh-dropdown
              class="ctr_btn"
              trigger="click"
              @visible-change="dropDownVisibleChange(row)"
              v-if="
                (permission?.view_report == 1 &&
                  !(childPremission && Number(childPremission.permission_data) === 0)) ||
                !(childPremission && Number(childPremission.permission_webinar_delete) === 0)
              "
              @command="commandMethod"
            >
              <vh-button type="text">{{ $t('lang.k_276038') }}</vh-button>
              <vh-dropdown-menu slot="dropdown">
                <vh-dropdown-item
                  command="/live/reportsData"
                  v-if="
                    permission?.view_report == 1 &&
                    !(childPremission && Number(childPremission.permission_data) === 0)
                  "
                >
                  {{ $t('lang.k_276025') }}
                </vh-dropdown-item>
                <vh-dropdown-item
                  command="/live/interactionData"
                  v-if="
                    permission?.view_report == 1 &&
                    !(childPremission && Number(childPremission.permission_data) === 0)
                  "
                >
                  {{ $t('lang.k_276026') }}
                </vh-dropdown-item>
                <vh-dropdown-item
                  command="/live/userData"
                  v-if="
                    permission?.view_report == 1 &&
                    !(childPremission && Number(childPremission.permission_data) === 0)
                  "
                >
                  {{ $t('lang.k_276027') }}
                </vh-dropdown-item>
                <!-- <vh-dropdown-item command='/live/edit' v-if="item.webinar_state!=4">{{ $t('lang.k_276023') }}</vh-dropdown-item> -->
                <vh-dropdown-item
                  v-if="
                    !(childPremission && Number(childPremission.permission_webinar_delete) === 0)
                  "
                  :command="$t('lang.k_276028')"
                >
                  {{ $t('lang.k_276028') }}
                </vh-dropdown-item>
              </vh-dropdown-menu>
            </vh-dropdown>
          </template>
        </vh-table-column>
      </vh-table>
      <SPagination
        :total="totalElement"
        :page-size="pageSize"
        :current-page="pageNum"
        :pageSizes="[12, 24, 36, 48, 60]"
        @current-change="currentChangeHandler"
        @size-change="sizeChange"
      ></SPagination>
    </div>
    <div class="no-live" v-if="!totalElement && !loading">
      <noData :nullType="nullText" :text="text">
        <vh-button
          type="primary"
          v-if="nullText == 'nullData'"
          round
          @click="createLiveAction('1')"
          v-preventReClick
          class="length152"
        >
          {{ $t('lang.k_276007') }}
        </vh-button>
        <vh-button
          round
          v-if="nullText == 'nullData' && vodPerssion == 1"
          class="transparent-btn length152"
          @click="createLiveAction('2')"
          v-preventReClick
        >
          {{ $t('lang.k_276008') }}
        </vh-button>
        <vh-button
          v-if="isTiming == 1"
          round
          @click="createLiveAction('3')"
          class="transparent-btn length152"
          v-preventReClick
        >
          {{ $t('lang.k_276009') }}
        </vh-button>
      </noData>
    </div>

    <!-- 绑定邮箱/手机号/修改密码 -->
    <ValidSetDialog ref="validSetDialog" @changeOk="changeOkHandle"></ValidSetDialog>
    <shareDialog
      :visible.sync="showShareDialog"
      v-if="showShareDialog"
      :webinar="curWebinar"
      :userId="userId"
    ></shareDialog>
  </div>
</template>

<script>
  import PageTitle from '@/components/PageTitle';
  import noData from '@/views/PlatformModule/Error/nullPage';
  import { sessionOrLocal, parseQueryString, jump, isEmbed } from '@/utils/utils';
  import ValidSetDialog from '@/views/AccountModule/components/validSetDialog.vue';
  import shareDialog from './components/shareDialog.vue';
  export default {
    data() {
      return {
        isEmbed: isEmbed(),
        lowerGradeInterval: null,
        liveStatus: 0,
        nullText: 'nullData',
        orderBy: 1,
        isSearch: false, //是否是搜索
        text: this.$t('lang.k_276039'),
        keyWords: '',
        pageSize: 12,
        pageNum: 1,
        pagePos: 0,
        userId: '',
        isAnginOpen: false,
        webinarInfo: {},
        totalElement: 0,
        liveDropDownVisible: false,
        statusOptions: [
          { label: this.$t('lang.k_276014'), value: 0 },
          { label: this.$t('lang.k_276040'), value: 2 },
          { label: this.$t('lang.k_276041'), value: 1 },
          { label: this.$t('lang.k_276042'), value: 3 },
          { label: this.$t('lang.k_276043'), value: 4 },
          { label: this.$t('lang.k_276021'), value: 5 }
        ],

        orderOptions: [
          { label: this.$t('lang.k_276044'), value: 1 },
          { label: this.$t('lang.k_276045'), value: 2 }
        ],

        modeOptions: [
          { label: this.$t('lang.k_276012'), value: undefined },
          { label: this.$t('lang.k_276046'), value: 2 },
          { label: this.$t('lang.k_276047'), value: 3 },
          { label: this.$t('lang.k_276048'), value: 1 },
          { label: this.$t('lang.k_276049'), value: 6 },
          { label: this.$t('lang.k_276050'), value: 5 }
        ],

        loading: true,
        liveList: [],
        isTiming: 0, //是否有定时直播权限
        labelList: [],
        labelId: '',
        modeType: undefined,
        activeStyle: localStorage.getItem('listActiveStyle') || 0,
        curWebinar: '',
        showShareDialog: ''
      };
    },
    computed: {
      childPremission: function () {
        return sessionOrLocal.get('SAAS_V3_SON_PS')
          ? JSON.parse(sessionOrLocal.get('SAAS_V3_SON_PS'))
          : {};
      },
      // admin无云导播活动权限
      webinarDirector() {
        //  webinar.director 1:有无延迟权限  0:无权限
        if (
          JSON.parse(sessionOrLocal.get('SAAS_VS_PES', 'localStorage'))['webinar.director'] == '1'
        ) {
          return true;
        } else {
          return false;
        }
      },
      permission() {
        return this.$store.state.permission;
      }
    },
    components: {
      ValidSetDialog,
      PageTitle,
      shareDialog,
      noData
    },
    created() {
      // 创建点播是否可用(全局)
      this.userId = JSON.parse(sessionOrLocal.get('userId'));
      const SAAS_VS_PES = JSON.parse(sessionOrLocal.get('SAAS_VS_PES', 'localStorage'));
      this.vodPerssion = SAAS_VS_PES['ui.upload_video_as_demand'];
      this.isTiming = SAAS_VS_PES['webinar.timing'];
      this.getLiveList();
      const permission = SAAS_VS_PES ? SAAS_VS_PES['no.delay.webinar'] : 0;
      this.isDelay = permission == 1 ? true : false;
      console.log('>>>>>>>10', this.isDelay);
      this.getLabelList();
    },
    beforeDestroy() {
      if (this.lowerGradeInterval) clearInterval(this.lowerGradeInterval);
    },
    methods: {
      changeStyle(val) {
        this.activeStyle = val;
        localStorage.setItem('listActiveStyle', val);
      },
      // 获取全部标签
      getLabelList() {
        this.$fetch('labelList', {
          webinar_id: this.keyWords,
          pos: 0,
          limit: 100
        }).then(res => {
          if (res.code == 200) {
            this.labelList = res.data.list;
            this.labelList.unshift({
              name: this.$t('lang.k_276013'),
              label_id: ''
            });

            // 该接口数据获取如果晚于列表数据，需要更新展示标签
            if (this.liveList && this.liveList.length > 0) {
              this.liveList.forEach(item => {
                const { displayLabel, labelTips } = this.getDisplayLabel(item.label_ids);
                item.displayLabel = displayLabel;
                item.labelTips = labelTips;
              });
            }
          }
        });
      },
      // 选择标签
      labelHandler() {
        this.searchHandler();
        if (this.liveStatus) {
          let livesType = [100050, 100049, 100051, 100052, 100053];
          this.$vhall_paas_port({
            k: livesType[this.liveStatus - 1],
            data: {
              business_uid: this.userId,
              user_id: '',
              webinar_id: '',
              refer: '',
              s: '',
              report_extra: {},
              ref_url: '',
              req_url: ''
            }
          });
        }
      },
      handleLowerGradeHeart() {
        this.getLowerGradeConfig();
      },
      getPermission(id, isPortraitScreen, item) {
        // 活动权限
        this.$fetch('planFunctionGet', {
          webinar_id: id,
          webinar_user_id: this.userId,
          scene_id: 1
        })
          .then(res => {
            if (res.code == 200) {
              let arr = [
                'component_1',
                'component_2',
                'component_3',
                'component_4',
                'component_5',
                'component_6',
                'component_7',
                'component_8',
                'component_9'
              ];

              if (res.data.permissions) {
                sessionOrLocal.set('WEBINAR_PES', res.data.permissions, 'localStorage');
                this.perssionInfo = JSON.parse(sessionOrLocal.get('WEBINAR_PES', 'localStorage'));
                console.log(this.perssionInfo, '>>>>>>1231<<<');
                this.isShow = true;
                this.isTrue = arr.some(item => {
                  // eslint-disable-next-line no-prototype-builtins
                  return this.perssionInfo[item] > 0;
                });
                this.hasDelayPermission =
                  this.perssionInfo['no.delay.webinar'] &&
                  this.perssionInfo['no.delay.webinar'] == 1
                    ? true
                    : false;
                const hasPortraitScreen =
                  this.perssionInfo['portrait_screen'] && this.perssionInfo['portrait_screen'] == 1
                    ? true
                    : false;
                // this.handleLowerGradeHeart()
                //  portrait_screen 是否支持竖屏 1:开启 0:关闭。
                if (!hasPortraitScreen && isPortraitScreen == 0) {
                  this.$vhMessage({
                    message: this.$t('lang.k_276051'),
                    showClose: true,
                    // duration: 0,
                    type: 'error',
                    customClass: 'zdy-info-box'
                  });
                  return;
                }
              } else {
                sessionOrLocal.removeItem('WEBINAR_PES');
              }
              if (item.webinar_state === 4) {
                // 点播
                jump({
                  path: `${isEmbed() ? '/embed' : ''}/live/vodEdit`,
                  query: { id: id, type: 3 }
                });
              } else {
                // 定时直播 或 其它
                const jumpPath = item.webinar_type == 5 ? 'timeEdit' : 'edit';
                jump({
                  path: `${isEmbed() ? '/embed' : ''}/live/${jumpPath}`,
                  query: { id: id, type: 3 }
                });
              }
            }
          })
          .catch(e => {
            console.log(e);
            sessionOrLocal.removeItem('SAAS_VS_PES');
          });
      },
      getLowerGradeConfig(id) {
        this.$fetch('lowerGrade', {})
          .then(res => {})
          .catch(res => {
            // 降级没有code吗
            const { activity, user, global } = res;
            // 优先顺序：互动 > 用户 > 全局
            const activityConfig =
              activity && activity.length > 0
                ? activity.find(option => option.audience_id == id)
                : null;
            const userConfig =
              user && user.length > 0
                ? user.find(option => option.audience_id == this.userId)
                : null;
            if (activityConfig) {
              this.setLowerGradeConfig(activityConfig.permissions);
            } else if (userConfig) {
              this.setLowerGradeConfig(userConfig.permissions);
            } else if (global && global.permissions) {
              this.setLowerGradeConfig(global.permissions);
            }
          });
      },
      setLowerGradeConfig(data) {
        console.log(data, 'data');
        if (this.lowerGradeInterval) clearInterval(this.lowerGradeInterval);
        let arr = [
          'component_1',
          'component_2',
          'component_3',
          'component_4',
          'component_5',
          'component_6',
          'component_7',
          'component_8',
          'component_9'
        ];

        let perssionInfo = JSON.parse(sessionOrLocal.get('WEBINAR_PES', 'localStorage'));
        perssionInfo = perssionInfo ? Object.assign(perssionInfo, data) : data;
        this.perssionInfo = perssionInfo;
        sessionOrLocal.set('WEBINAR_PES', perssionInfo, 'localStorage');
        if (this.lowerGradeInterval) clearInterval(this.lowerGradeInterval);
        // const SAAS_VS_PES = JSON.parse(sessionOrLocal.get('SAAS_VS_PES', 'localStorage'))

        this.vodPerssion = perssionInfo['ui.upload_video_as_demand'];
        this.isTiming = perssionInfo['webinar.timing'];
        const permission = perssionInfo ? perssionInfo['no.delay.webinar'] : 0;
        this.isDelay = permission == 1 ? true : false;
      },
      toLiveDetail(webinar_id) {
        this.$vhall_paas_port({
          k: 100046,
          data: {
            business_uid: this.userId,
            user_id: '',
            webinar_id: webinar_id,
            refer: '',
            s: '',
            report_extra: {},
            ref_url: '',
            req_url: ''
          }
        });
        jump({
          path: `${isEmbed() ? '/embed' : ''}/live/detail/${webinar_id}`
        });
      },
      nullFunc() {
        return false;
      },
      modeHandler() {
        this.searchHandler();
      },
      liveHandler() {
        this.searchHandler();
        if (this.liveStatus) {
          let livesType = [100050, 100049, 100051, 100052, 100053];
          this.$vhall_paas_port({
            k: livesType[this.liveStatus - 1],
            data: {
              business_uid: this.userId,
              user_id: '',
              webinar_id: '',
              refer: '',
              s: '',
              report_extra: {},
              ref_url: '',
              req_url: ''
            }
          });
        }
      },
      orderHandler() {
        this.searchHandler();
        this.$vhall_paas_port({
          k: this.orderBy == 1 ? 100047 : 100048,
          data: {
            business_uid: this.userId,
            user_id: '',
            webinar_id: '',
            refer: '',
            s: '',
            report_extra: {},
            ref_url: '',
            req_url: ''
          }
        });
      },
      searchHandler() {
        this.pageNum = 1;
        this.pagePos = 0;
        this.getLiveList();
      },
      dropDownVisibleChange(item) {
        this.$set(item, 'liveDropDownVisible', !item.liveDropDownVisible);
        this.webinarInfo = item;
      },
      commandMethod(command) {
        if (command === this.$t('lang.k_276028')) {
          if (this.webinarInfo.webinar_state == 1) {
            this.$vhMessage({
              message: this.$t('lang.k_276052'),
              showClose: true,
              // duration: 0,
              type: 'error',
              customClass: 'zdy-info-box'
            });
            return;
          }
          this.$vhConfirm(this.$t('lang.k_276053'), this.$t('lang.k_276054'), {
            confirmButtonText: this.$t('lang.k_276055'),
            cancelButtonText: this.$t('lang.k_276056'),
            customClass: 'zdy-message-box',
            lockScroll: false,
            roundButton: true,
            cancelButtonClass: 'zdy-confirm-cancel'
          })
            .then(() => {
              this.deleteLive();
            })
            .catch(() => {
              this.$vhMessage({
                message: `${this.$t('lang.k_276057')}`,
                showClose: true,
                // duration: 0,
                type: 'info',
                customClass: 'zdy-info-box'
              });
            });
        } else {
          let num =
            command === '/live/reportsData'
              ? 100042
              : command === '/live/interactionData'
              ? 100043
              : 100044;
          // 新标签页打开
          // this.$router.push({path: `${command}/${this.webinarInfo.webinar_id}`, query: {roomId: this.webinarInfo.vss_room_id, status: this.webinarInfo.webinar_state }});
          this.$vhall_paas_port({
            k: num,
            data: {
              business_uid: this.userId,
              user_id: '',
              webinar_id: this.webinarInfo.webinar_id,
              s: '',
              refer: 1,
              report_extra: {},
              ref_url: '',
              req_url: ''
            }
          });
          jump({
            path: `${isEmbed() ? '/embed' : ''}${command}/${this.webinarInfo.webinar_id}`,
            query: { roomId: this.webinarInfo.vss_room_id, status: this.webinarInfo.webinar_state }
          });
        }
      },
      currentChangeHandler(current) {
        this.pageNum = current;
        this.pagePos = parseInt((current - 1) * this.pageSize);
        this.getLiveList();
      },
      sizeChange(current) {
        this.pageNum = 1;
        this.pageSize = current;
        this.pagePos = 0;
        this.getLiveList();
      },
      // 解析图片地址
      handlerImageInfo(url) {
        let obj = parseQueryString(url);
        return Number(obj.mode) || 3;
      },
      // 列表显示分类标签
      getDisplayLabel(label_ids) {
        let displayLabel = '';
        let labelTips = '';
        if (label_ids && this.labelList && this.labelList.length > 0) {
          const labelIds = label_ids.split(',').map(Number);
          const currentLabelId = this.labelId ? this.labelId : labelIds[0];
          const labelItem = this.labelList.find(item => item.label_id == currentLabelId);
          if (labelItem) {
            displayLabel = labelItem.name;
          }
          labelTips = this.labelList
            .filter(item => {
              return labelIds.includes(item.label_id);
            })
            .map(item => item.name)
            .join(',');
        }
        return { displayLabel, labelTips };
      },
      getLiveList() {
        let data = {
          pos: this.pagePos,
          limit: this.pageSize,
          order_type: this.orderBy,
          title: this.keyWords,
          webinar_state: this.liveStatus,
          label_id: this.labelId,
          webinar_type: this.modeType
        };
        this.loading = true;
        this.$fetch('liveList', this.$params(data))
          .then(res => {
            const liveList = res.data.list;
            liveList.map(item => {
              // 非化蝶活动，若超过1v5，默认展示1v5
              item.zdy_inav_num = item.is_new_version != 3 && item.inav_num > 6 ? 6 : item.inav_num;
              item.itemMode = this.handlerImageInfo(item.img_url);
              // 待展示的标签
              const { displayLabel, labelTips } = this.getDisplayLabel(item.label_ids);
              item.displayLabel = displayLabel;
              item.labelTips = labelTips;
            });
            this.liveList = liveList;
            this.totalElement = res.data.total;
            // 搜索状态
            this.nullText = 'search';
            this.text = '';
            this.isSearch = true;
          })
          .catch(res => {
            this.$vhMessage({
              message: res.msg || this.$t('lang.k_276058'),
              showClose: true,
              // duration: 0,
              type: 'error',
              customClass: 'zdy-info-box'
            });
            console.log(res);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      deleteLive() {
        this.$fetch('liveDel', { webinar_ids: this.webinarInfo.webinar_id })
          .then(res => {
            this.$vhall_paas_port({
              k: 100045,
              data: {
                business_uid: this.userId,
                user_id: '',
                webinar_id: this.webinarInfo.webinar_id,
                refer: '',
                s: '',
                report_extra: {},
                ref_url: '',
                req_url: ''
              }
            });
            this.$vhMessage({
              message: `${this.$t('lang.k_276059')}`,
              showClose: true,
              // duration: 0,
              type: 'success',
              customClass: 'zdy-info-box'
            });
            // 刷新列表
            this.searchHandler();
          })
          .catch(res => {
            this.$vhMessage({
              message: res.msg || `${this.$t('lang.k_276060')}`,
              showClose: true,
              // duration: 0,
              type: 'error',
              customClass: 'zdy-info-box'
            });
          });
      },
      getAppersInfo(item) {
        this.$fetch('getVersionInfo', { user_id: this.userId })
          .then(res => {
            if (res.data.arrears.total_fee > 0) {
              this.$vhConfirm(
                this.$t('lang.k_276061', [
                  res.data.type == 1
                    ? this.$t('lang.k_276062')
                    : res.data.type == 2
                    ? this.$t('lang.k_276063')
                    : this.$t('lang.k_276064'),
                  res.data.type == 2 ? this.$t('lang.k_276065') : this.$t('lang.k_276066')
                ]),
                this.$t('lang.k_276054'),

                {
                  confirmButtonText:
                    res.data.type == 2 ? this.$t('lang.k_276067') : this.$t('lang.k_276068'),
                  cancelButtonText: this.$t('lang.k_276067'),
                  customClass: 'zdy-message-box',
                  lockScroll: false,
                  confirmButtonPosition: 'left',
                  roundButton: true,
                  showCancelButton: res.data.type == 2 ? false : true,
                  cancelButtonClass: 'zdy-confirm-cancel'
                }
              )
                .then(() => {
                  if (res.data.type == 2) return;
                  this.$router.push({ path: '/plan/info' });
                })
                .catch(() => {});
            } else {
              if (item.webinar_state == 1) {
                this.getOpenLive(item);
              } else {
                this.goIsLive(item);
              }
            }
          })
          .catch(e => {
            console.log(e);
          });
      },
      goLivePlay(item) {
        //判断是否可以开播
        this.getAppersInfo(item);
      },
      goPlayback(item) {
        this.$vhall_paas_port({
          k: 100039,
          data: {
            business_uid: this.userId,
            user_id: '',
            webinar_id: item.webinar_id,
            refer: '',
            s: '',
            report_extra: {},
            ref_url: '',
            req_url: ''
          }
        });
        jump({
          path:
            item.webinar_state == 4
              ? `${isEmbed() ? '/embed' : ''}/live/recordplayback/${item.webinar_id}`
              : `${isEmbed() ? '/embed' : ''}/live/playback/${item.webinar_id}?type=${
                  item.webinar_type
                }`
        });
      },
      goIsLive(item) {
        this.$vhall_paas_port({
          k: 100038,
          data: {
            business_uid: this.userId,
            user_id: '',
            webinar_id: item.webinar_id,
            refer: '',
            s: '',
            report_extra: {},
            ref_url: '',
            req_url: ''
          }
        });
        if (item.webinar_type != 1) {
          const { href } = this.$router.resolve({
            path: `/live/chooseWay/${item.webinar_id}/1?type=ctrl`
          });
          window.self == window.top ? window.open(href, '_blank') : (window.location.href = href);
        } else {
          let href = `${window.location.origin}${process.env.VUE_APP_WEB_KEY}/lives/room/${item.webinar_id}`;
          window.self == window.top ? window.open(href, '_blank') : (window.location.href = href);
        }
      },
      // 判断是否有起直播的权限
      getOpenLive(item) {
        this.$fetch(
          'checkLive',
          this.$params({
            webinar_id: item.webinar_id
          })
        )
          .then(res => {
            if (res.code == 200) {
              this.goIsLive(item);
            } else {
              // 不能发起
              this.$vhMessage({
                message: this.$t('lang.k_276069'),
                showClose: true,
                // duration: 0,
                type: 'error',
                customClass: 'zdy-info-box'
              });
              return;
            }
          })
          .catch(e => {
            this.$vhMessage({
              message: this.$t('lang.k_276069'),
              showClose: true,
              // duration: 0,
              type: 'error',
              customClass: 'zdy-info-box'
            });
            return;
          });
      },
      // 创建活动
      createLiveAction(index) {
        console.log('账号下最多创建100个直播标签');
        let userInfo = JSON.parse(sessionOrLocal.get('userInfo'));
        if (!userInfo.phone && userInfo.user_extends.extends_remark != 2) {
          this.$vhAlert(this.$t('lang.k_276070'), this.$t('lang.k_276054'), {
            confirmButtonText: this.$t('lang.k_276071'),
            customClass: 'zdy-message-box',
            lockScroll: false,
            cancelButtonClass: 'zdy-confirm-cancel',
            callback: action => {
              if (action === 'confirm') {
                if (this.isEmbed) {
                  this.$nextTick(() => {
                    this.currentCreateLiveActionIndex = index;
                    this.$refs.validSetDialog.initComp({}, 'phone');
                  });
                  return true;
                }
                this.$router.push({ path: '/acc/info', query: { tab: 1 } });
              }
            }
          });
        } else {
          let url = index == 1 ? '/live/edit' : index == 2 ? '/live/vodEdit' : '/live/timeEdit';
          this.$router.push({ path: `${isEmbed() ? '/embed' : ''}${url}`, query: { refer: 3 } });
        }
      },
      toDetail(id, state) {
        this.$vhall_paas_port({
          k: 100040,
          data: {
            business_uid: this.userId,
            user_id: '',
            webinar_id: id,
            refer: '',
            s: '',
            report_extra: {},
            ref_url: '',
            req_url: ''
          }
        });
        jump({
          path: `${isEmbed() ? '/embed' : ''}/live/detail/${id}`
        });
      },
      toRoom(id) {
        const { href } = this.$router.resolve({ path: `/lives/room/${id}` });
        window.open(href);
      },
      toCopy(id, isPortraitScreen, item) {
        this.$vhConfirm(this.$t('lang.k_276072'), this.$t('lang.k_276073'), {
          confirmButtonText: this.$t('lang.k_276055'),
          cancelButtonText: this.$t('lang.k_276056'),
          customClass: 'zdy-message-box',
          lockScroll: false,
          roundButton: true,
          confirmButtonPosition: 'right',
          cancelButtonClass: 'zdy-confirm-cancel'
        })
          .then(() => {
            this.$vhall_paas_port({
              k: 100041,
              data: {
                business_uid: this.userId,
                user_id: '',
                webinar_id: id,
                refer: '',
                s: '',
                report_extra: {},
                ref_url: '',
                req_url: ''
              }
            });
            this.getPermission(id, isPortraitScreen, item);
          })
          .catch(() => {});
      },
      toShare(webinar) {
        this.curWebinar = webinar;
        this.showShareDialog = true;
      },
      changeOkHandle() {
        // 保存成功，数据更新
        this.$fetch('getInfo', {
          scene_id: 2
        })
          .then(res => {
            sessionOrLocal.set('userInfo', JSON.stringify(res.data));
            sessionOrLocal.set('userId', JSON.stringify(res.data.user_id));
            this.$EventBus.$emit('saas_vs_account_change', res.data);
            this.createLiveAction(this.currentCreateLiveActionIndex);
          })
          .catch(res => {
            this.$vhMessage({
              message: res.msg || `${this.$t('lang.k_276074')}`,
              showClose: true,
              // duration: 0,
              type: 'error',
              customClass: 'zdy-info-box'
            });
          });
      }
    }
  };
</script>
<style lang="less" scoped>
  .changeOption {
    border-radius: 100px;
    border: 1px solid #e6e6e6;
    display: inline-block;
    cursor: pointer;
    background: #fff;
    margin-right: 10px;
    span {
      display: inline-block;
      font-size: 14px;
      color: #666;
      padding: 13px;
      border-radius: 100px;
    }
    .span-active {
      border: none;
      background: #fb3a32;
      color: #fff;
      border-radius: 100px;
    }
  }
  .pageTitle {
    color: #1a1a1a;
    font-size: 22px;
    font-weight: 600;
  }
  .operaBox {
    overflow: hidden;
    margin-top: 12px;
    margin-bottom: 20px;
    .searchBox {
      float: right;
      .vh-select {
        width: 150px;
        margin-right: 8px;
      }
      .small {
        width: 110px;
      }
    }
  }
  .lives {
    &.lives-list .liveItem {
      .top {
        height: 86px;
        border-radius: 4px;
        padding: 6px;
        .liveTag {
          font-size: 10px;
        }
        .hot i {
          font-size: 12px;
          left: 8px;
          bottom: 4px;
        }
      }
      .ctr_btn {
        margin-left: 10px;
      }
      .liveTitle {
        font-size: 14px;
      }
    }
    .liveItem {
      height: 314px;
      margin-bottom: 24px;
      .inner {
        transition: all 0.15s ease-in;
        position: relative;
        border-radius: 4px;
        display: inline-block;
        width: 100%;
        cursor: pointer;
      }
      .inner:hover {
        box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.15);
        border-radius: 4px;
      }
      .top {
        height: 176.35px;
        background: #1a1a1a;
        padding: 10px 10px;
        box-sizing: border-box;
        position: relative;
        border-radius: 4px 4px 0 0;
        overflow: hidden;
        .img-box {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          border-radius: 4px 4px 0 0;
          overflow: hidden;
          .img_box_bg {
            width: 100%;
            height: 100%;
            object-fit: contain;
            object-position: center;
            cursor: pointer;
            font-size: 0;
            &.webinar_bg_1 {
              object-fit: fill;
            }
            &.webinar_bg_2 {
              object-fit: cover;
              object-position: left top;
            }
          }
        }

        .liveTag {
          background: rgba(0, 0, 0, 0.7);
          color: #fff;
          font-size: 12px;
          padding: 3px 8px;
          border-radius: 20px;
          position: relative;
          z-index: 2;
        }
        .live-status {
          display: inline-block;
          width: 8px;
          height: 8px;
          margin: 0 6px 0 2px;
          img {
            width: 100%;
            height: 100%;
            object-fit: scale-down;
          }
        }
        .hot {
          position: absolute;
          height: 50px;
          width: 100%;
          background: linear-gradient(180deg, transparent, rgba(0, 0, 0, 0.6));
          bottom: 0px;
          left: 0px;
          color: #fff;
          font-size: 14px;
          z-index: 2;
          cursor: pointer;
          i {
            position: absolute;
            left: 14px;
            bottom: 10px;
          }
        }
      }
      .bottom {
        height: 139px;
        background: #fff;
        box-sizing: border-box;
        padding: 14px 14px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        border-radius: 0 0 4px 4px;

        .liveTime {
          font-size: 14px;
          color: #666;
        }
        .liveOpera {
          color: #666666;
          font-size: 18px;
          cursor: default;
          a {
            color: rgb(44, 43, 43);
          }
          i {
            cursor: pointer;
            margin-right: 20px;
            &:last-child {
              margin-right: 0;
            }
          }
          /deep/.iconfont-v3 {
            font-size: 18px;
          }
          .vh-dropdown {
            float: right;
            i {
              margin-right: 0;
            }
            &.active {
              z-index: 2;
            }
          }
          .item {
            &:hover {
              color: #222;
            }
          }
          .vh-dropdown :hover {
            color: #222;
          }
        }
      }
      .liveTitle {
        color: #1a1a1a;
        font-size: 16px;
        margin-bottom: 8px;
        line-height: 24px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
  }

  .card-display-label {
    position: absolute;
    right: 10px;
    bottom: 10px;
    max-width: 120px;
    font-size: 14px;
    color: #fff;
    text-align: right;
    // background: rgba(0, 0, 0, 0.4);
    // padding: 3px 8px;
    // border-radius: 40px;
  }
  .single-ellips {
    max-width: 120px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
  }
  .label-tip-content {
    max-width: 160px;
  }

  @keyframes gradientBG {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
  .liveListBox {
    margin: auto;
    width: 1020px;
  }
  @media screen and (min-width: 1920px) {
    .liveListBox {
      margin: auto;
      width: 1374px;
    }
  }
</style>
<style lang="less">
  .vh-tooltip__popper {
    max-width: 100%;
  }
  .dropdown_width {
    .length104 {
      width: 147px;
    }
    .vh-dropdown-menu__item {
      text-align: left;
    }
  }
</style>
<style lang="css">
  html {
    background: #f7f7f7;
  }
</style>
